import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
  input: {
    paddingTop: 13,
    paddingBottom: 13
  }
}));
